import styled from 'styled-components';
import Arrow from 'assets/arrow.svg';

export const Wrapper = styled.span`
  white-space: nowrap;

  span.text {
    white-space: normal;
  }

  ::after {
    content: ' ';
    display: inline-block;

    height: 1.1em;
    aspect-ratio: 1;

    vertical-align: bottom;
    margin-bottom: 0.15em;

    background-image: url('${Arrow}');
    background-repeat: no-repeat;
    background-position: center;
    background-size: auto 100%;

    transform: rotate(180deg);
  }
`;
